import { RemoteDeleteFieldAssessments } from 'data/usecases';
import { makeApiUrlFieldAssessments } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteFieldAssessments =
  (): RemoteDeleteFieldAssessments => {
    return new RemoteDeleteFieldAssessments(
      makeApiUrlFieldAssessments(),
      makeAxiosHttpClient(),
    );
  };
